var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingdefault flexcenter"},[_c('div',[_vm._m(0),_c('div',{staticClass:"defaultnote"},[_vm._v(_vm._s(_vm.msg || _vm.msgdefault))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexcenter imgbox"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loading-slide"},[_c('div',{staticClass:"slide"}),_c('div',{staticClass:"slide"}),_c('div',{staticClass:"slide"})])])])
}]

export { render, staticRenderFns }